{
  "promoter": {
    "auth": {
      "title": "Sign in to Coreway Partners",
      "subtitle": "For promoters invited to the Coreway program.",
      "email": "Email",
      "password": "Password",
      "signIn": "Sign in",
      "signingIn": "Signing in…",
      "useLink": "Email me a sign-in link",
      "usePassword": "Sign in with a password",
      "or": "or",
      "google": "Continue with Google",
      "apple": "Continue with Apple",
      "link": {
        "title": "Get a sign-in link",
        "body": "Enter the email your invitation was sent to. We will email you a link and a code.",
        "send": "Email me a link",
        "sending": "Sending…",
        "sentTitle": "Check your email",
        "sent": "If {{email}} can sign in, a link and a code are on their way. Open the link in this browser, or type the code below.",
        "code": "Code from the email",
        "verify": "Sign in with the code",
        "verifying": "Checking…",
        "otherEmail": "Use another email"
      },
      "errors": {
        "tooManyEmails": "Too many emails were sent. Wait a few minutes and try again.",
        "invalidEmail": "Enter a valid email address.",
        "linkExpired": "This sign-in link or code has expired or was already used. Ask for a new one.",
        "linkOtherBrowser": "Open the sign-in link in the same browser where you asked for it, or type the code from the email.",
        "otherAccount": "That link belongs to another account.",
        "weakPassword": "Choose a longer password (at least 8 characters).",
        "samePassword": "That is already your password.",
        "invalidCredentials": "Wrong email or password.",
        "network": "We could not reach Coreway. Check your connection and try again.",
        "generic": "We could not sign you in. Please try again.",
        "oauthCancelled": "Sign-in was cancelled.",
        "oauthFailed": "Sign-in with that provider failed. Please try again.",
        "oauthUnavailable": "That sign-in option is not available right now.",
        "identityTaken": "That provider account is already linked to another user.",
        "otherAccountOAuth": "That provider account belongs to another user."
      }
    }
  }
}
